import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "https://porfolio-backend-production-aab2.up.railway.app/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(
        `${API}/auth/login`,
        form
      );
      localStorage.setItem("adminToken", res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      const msg =
        err.response?.data?.message || "Login failed. Check your credentials.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      background: "radial-gradient(ellipse 60% 50% at 50% 0%, rgba(124,58,237,0.1) 0%, transparent 70%)",
    }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 28 }}>
            Ariyom<span style={{ color: "var(--accent)" }}>Tech</span>
          </span>
          <p style={{ color: "var(--muted)", marginTop: 8, fontSize: 14 }}>Admin Login</p>
        </div>

        <div className="card">
          <h2 style={{ fontWeight: 700, marginBottom: 24, fontSize: 20 }}>🔐 Sign In</h2>

          {error && (
            <div style={{
              background: "rgba(255,71,87,0.1)",
              border: "1px solid rgba(255,71,87,0.3)",
              borderRadius: 8,
              padding: "10px 14px",
              marginBottom: 20,
              color: "#ff4757",
              fontSize: 14,
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>
                Email
              </label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="admin@ariyomtech.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>
                Password
              </label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              style={{
                padding: "12px",
                fontSize: 15,
                justifyContent: "center",
                marginTop: 8,
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? "Signing in…" : "Sign In →"}
            </button>
          </form>

          <p style={{ color: "var(--muted)", fontSize: 12, marginTop: 20, textAlign: "center" }}>
            Secured with <code style={{ color: "var(--accent)" }}>JWT Authentication</code>
          </p>
        </div>
      </div>
    </div>
  );
}